/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Team_Sync_Register_Job_ErrorInputs */



/**
* | output |
* | --- |
* | "Unable to register project sync job: {message}" |
*
* @param {Team_Sync_Register_Job_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_sync_register_job_error = /** @type {((inputs: Team_Sync_Register_Job_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Sync_Register_Job_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Impossible d’enregistrer la tâche de synchronisation du projet : ${i?.message}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Projektsynchronisierungsauftrag konnte nicht registriert werden: ${i?.message}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile registrare il processo di sincronizzazione del progetto: ${i?.message}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось зарегистрировать задание синхронизации проекта: ${i?.message}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`No se puede registrar el trabajo de sincronización del proyecto: ${i?.message}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`无法注册项目同步作业：${i?.message}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`プロジェクト同期ジョブを登録できません: ${i?.message}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`प्रोजेक्ट सिंक जॉब को पंजीकृत करने में असमर्थ: ${i?.message}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Não foi possível registrar a tarefa de sincronização do projeto: ${i?.message}`)
	return /** @type {LocalizedString} */ (`Unable to register project sync job: ${i?.message}`)
});